/* import __COLOCATED_TEMPLATE__ from './adi-component.hbs'; */
import Component from '@glimmer/component';
import AdiGeneric from './adi-generic';

export default class AdiComponent extends Component {
  _updateAppData = this.args.updateAppData ?? (() => {});
  _typeMap = this.args.typeMap ?? {};
  source = this.args.source ?? AdiGeneric;
}
